// extracted by mini-css-extract-plugin
module.exports = {"supportBar":"style_supportBar__2iQA9","home":"style_home__27JKd"};